import React from 'react';
// styles
import styled from 'styled-components';

const InstructionsIcon = ({ className, ...props }) => (
  <svg
    {...props}
    role="img"
    aria-label="Instructions"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 6.00006H8C6.9 6.00006 6 6.90006 6 8.00006V26.0001L10 22.0001H24C25.1 22.0001 26 21.1001 26 20.0001V8.00006C26 6.90006 25.1 6.00006 24 6.00006ZM23 17.0001L20.5 15.5001L18 17.0001V9.00006H23V17.0001Z"
      fill="#94A6B8"
    />
  </svg>
);

export default styled(InstructionsIcon)``;
